var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRadioButtonChecked = function SvgRadioButtonChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M506.458 307.2C393.41 307.2 301.66 398.95 301.66 512s91.75 204.8 204.798 204.8c113.05 0 204.8-91.75 204.8-204.8s-91.75-204.8-204.8-204.8m0-204.8C280.361 102.4 96.86 285.901 96.86 512s183.501 409.6 409.598 409.6c226.099 0 409.6-183.501 409.6-409.6s-183.501-409.6-409.6-409.6m0 737.28C325.417 839.68 178.78 693.043 178.78 512s146.637-327.68 327.678-327.68c181.043 0 327.68 146.637 327.68 327.68s-146.637 327.68-327.68 327.68"
  })));
};
export default SvgRadioButtonChecked;